import { IsNumber, IsOptional, IsString } from 'class-validator';

export class SearchRuleModel {
  @IsOptional()
  @IsNumber()
  declare pageSize: number | undefined;

  @IsOptional()
  @IsString()
  declare pageToken: string | undefined;
}
